'use strict';

require('../../style/index.less');

require('../../popover/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/popconfirm/style/index.js
 ** module id = 207
 ** module chunks = 0
 **/